<div class="formulaire-trajet">
	<div class="formulaire-trajet-header">
		<div class="titre-formulaire-trajet">
			{{ titreFormulaire() | translate }}
		</div>
		<p-button class="bouton-fermer"
		          icon="pi pi-times"
		          styleClass="p-button-link"
		          (onClick)="fermerFormulaire()">
		</p-button>
	</div>
	<form [formGroup]="formTrajet" (ngSubmit)="submitFormulaire()" class="form-trajet">
		<div class="form-champs">
			<label class="label" for="lieuDepart">
				{{ 'GESTION_NAVETTE.LIEU_DEPART' | translate }}
				<span class="obligatoire"> {{ 'GLOBAL.CHAMP_OBLIGATOIRE' | translate }}</span>
			</label>
			<div class="input-et-erreur">
				<input id="lieuDepart" type="text" pInputText formControlName="lieuDepart" maxlength="100"/>
				@if (getMessageErreurChamp('lieuDepart'); as cleErreur) {
					<span class="erreur-validation">{{ cleErreur | translate }}</span>
				}
			</div>
			<label class="label" for="adresseDepart">
				{{ 'GESTION_NAVETTE.ADRESSE_DEPART' | translate }}
			</label>
			<div class="input-et-erreur">
				<input id="adresseDepart" type="text" pInputText formControlName="adresseDepart" maxlength="200"
				       [placeholder]="'GESTION_NAVETTE.PLACEHOLDER_ADRESSE' | translate"/>
			</div>
			<label class="label" for="lieuArrivee">
				{{ 'GESTION_NAVETTE.LIEU_ARRIVEE' | translate }}
				<span class="obligatoire"> {{ 'GLOBAL.CHAMP_OBLIGATOIRE' | translate }}</span>
			</label>
			<div class="input-et-erreur">
				<input id="lieuArrivee" type="text" pInputText formControlName="lieuArrivee" maxlength="100"/>
				@if (getMessageErreurChamp('lieuArrivee'); as cleErreur) {
					<span class="erreur-validation">{{ cleErreur | translate }}</span>
				}
			</div>
			<label class="label" for="adresseArrivee">
				{{ 'GESTION_NAVETTE.ADRESSE_ARRIVEE' | translate }}
			</label>
			<div class="input-et-erreur">
				<input id="adresseArrivee" type="text" pInputText formControlName="adresseArrivee" maxlength="200"
				       [placeholder]="'GESTION_NAVETTE.PLACEHOLDER_ADRESSE' | translate"/>
			</div>
			@if (getMessageErreurLieux(); as cleErreur) {
				<span class="erreur-validation erreur-validation--pleine-largeur">{{ cleErreur | translate }}</span>
			}
			<label class="label" for="dateDepart">
				{{ 'GESTION_NAVETTE.TRAJETS.FORMULAIRE.DATE_DEPART' | translate }}
				<span class="obligatoire"> {{ 'GLOBAL.CHAMP_OBLIGATOIRE' | translate }}</span>
			</label>
			<div class="input-et-erreur">
				<p-calendar inputId="dateDepart"
				            formControlName="dateDepart"
				            dateFormat="dd/mm/yy"
				            [showTime]="true"
				            appendTo="body"
				            [minDate]="aujourdhui"
				            [showIcon]="true"
				            iconDisplay="input"/>
				@if (getMessageErreurChamp('dateDepart'); as cleErreur) {
					<span class="erreur-validation">{{ cleErreur | translate }}</span>
				}
			</div>
			<label class="label" for="dateArrivee">
				{{ 'GESTION_NAVETTE.TRAJETS.FORMULAIRE.DATE_ARRIVEE' | translate }}
				<span class="obligatoire"> {{ 'GLOBAL.CHAMP_OBLIGATOIRE' | translate }}</span>
			</label>
			<div class="input-et-erreur">
				<p-calendar inputId="dateArrivee"
				            formControlName="dateArrivee"
				            dateFormat="dd/mm/yy"
				            [showTime]="true"
				            appendTo="body"
				            [minDate]="aujourdhui"
				            [showIcon]="true"
				            iconDisplay="input"/>
				@if (getMessageErreurChamp('dateArrivee'); as cleErreur) {
					<span class="erreur-validation">{{ cleErreur | translate }}</span>
				}
			</div>
			@if (getMessageErreurDates(); as cleErreur) {
				<span class="erreur-validation erreur-validation--pleine-largeur">{{ cleErreur | translate }}</span>
			}
			<label class="label" for="nombrePlaces">
				{{ 'GESTION_NAVETTE.NOMBRE_PLACES' | translate }}
				<span class="obligatoire"> {{ 'GLOBAL.CHAMP_OBLIGATOIRE' | translate }}</span>
			</label>
			<div class="input-et-erreur">
				<p-inputNumber inputId="nombrePlaces" class="nombre-places-input" formControlName="nombrePlaces" maxlength="3" [min]="1"/>
				@if (getMessageErreurChamp('nombrePlaces'); as cleErreur) {
					<span class="erreur-validation">{{ cleErreur | translate }}</span>
				}
			</div>
			<div class="info-utiles">
				<label for="informations">{{ 'GESTION_NAVETTE.INFORMATIONS' | translate }}</label>
				<textarea id="informations"
				          rows="5"
				          cols="30"
				          pInputTextarea
				          [autoResize]="false"
				          formControlName="informations"
				          maxlength="255"></textarea>
			</div>
		</div>
		<div class="boutons">
			<p-button type="button"
			          (onClick)="fermerFormulaire()"
			          styleClass="p-button-link"
			          label="{{ 'GLOBAL.BTN_FERMER' | translate }}"/>
			<p-button type="submit"
			          [icon]="iconeBoutonSubmit()"
			          [label]="labelBoutonSubmit() | translate"/>
		</div>
	</form>
</div>
